import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_VENDOR_CHAUFFEURS, GET_VENDOR_CHAUFFEURS_SUCCESS, GET_VENDOR_CHAUFFEURS_ERROR } from './../../../actionType.js';
import apiCall from '../../../apiCall';

function* getVendorChauffeurs({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/vendor/chauffeur`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_VENDOR_CHAUFFEURS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_VENDOR_CHAUFFEURS_ERROR,
        payload: response?.response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_VENDOR_CHAUFFEURS_ERROR, payload: error });
  }
}

export function* watchGetVendorChauffeurs() {
  yield takeEvery(GET_VENDOR_CHAUFFEURS, getVendorChauffeurs);
}

function* getVendorChauffeursSaga() {
  yield all([fork(watchGetVendorChauffeurs)]);
}

export default getVendorChauffeursSaga;
